import React, { memo } from "react";

import GoogleAd from "@/components/GoogleAd/GoogleAd";
import ShopItemCardSkeleton from "@/components/ShopItemCard/ShopItemCardSkeleton";

import styles from "./ShopItemAd.module.css";

type ShopItemAdProps = {
  slot: number;
  targeting?: Record<string, string | string[] | undefined | null>;
};

const ShopItemAd: React.FC<ShopItemAdProps> = ({ slot, targeting = {} }) => {
  return (
    <GoogleAd
      adPath={`/13212770/shop_slot_${slot}`}
      className={`shadow-low rounded ${styles["shop-ad"]}`}
      targeting={targeting}
      enableResizeRefresh={false}
    >
      <ShopItemCardSkeleton />
    </GoogleAd>
  );
};

export default memo(ShopItemAd);
